import styled from '@emotion/styled'
import { Button } from '@mui/material'
import { colors, size } from '@styles/theme'
import { Link } from 'react-router-dom'


const BackgroundImg = styled.img`
  position: absolute;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: center;
  filter: grayscale(1) brightness(0.075);
  z-index: 0;
`

const BackgroundImage = ({ ...rest }) => (
  <BackgroundImg
    style={{ minHeight: document.body.offsetHeight }}
    {...rest}
  />
)

const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  position: relative;
`

const FormTitle = styled.h1`
  marginBottom: ${size(6)};
`

const InputContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 ${size(1)};
`

const LinksContainer = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: ${size(4)};
  width: 100%;
`

const FormLink = styled(Link)`
  text-align: center;
  flex-shrink: 0;
  color: ${colors.statusColors.chatting('light')};
`

const BottomButtonGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  // position: absolute;
  position: fixed;
  bottom: 0px;

  width: 100%;
`

const ActionButton = styled(Button)`
  // background: linear-gradient(139deg, #1976D2 23.12%, #1DE4D0 108.2%);
  background: linear-gradient(172.5deg, #2293EE 23.12%, #751DE4 110%);
  // background-color: ${colors.statusColors.right_now('primary')};
  color: white !important;
  flex-grow: 2;
  flex-shrink: 0;
  padding: ${size(1.5)} 0;
  margin: ${size(0.5)};
  border-radius: 100px;
  font-weight: bold;
`

const ButtonGroupClearFix = styled.div`
  height: ${size(8)};
  width: 100%;
  flex-shrink: 0;
`

const RightLabelText = styled.u`
  display: flex;
  align-items: center;
  margin-right: ${size(0.5)};
  color: ${colors.statusColors.chatting('light')};
`

const FlexSpacerDiv = styled.div``

export {
  BackgroundImage,
  FormContainer,
  FormTitle,
  InputContainer,
  LinksContainer,
  FormLink,
  BottomButtonGroup,
  ActionButton,
  ButtonGroupClearFix,
  RightLabelText,
  FlexSpacerDiv,
}
